<script lang="ts">
    import { Checkbox, Dot, Table } from 'attractions';
    import { toasts } from 'svelte-toasts';
    import Employee from "../../Models/Employee";
    import { LATEST_PURCHASE } from "../../Stores/Purchase";
    import Currency from "../../Utils/Currency";
    import PurchasePaymentConfirmationDialog from "./PurchasePaymentConfirmationDialog.svelte";

    const headers = [
        { text: 'Data', value: 'date' },
        { text: 'Produkt', value: 'product' },
        { text: "Status", value: 'paid' },
        { text: 'Cena', value: 'price' }
    ]

    let items: any[];
    let paymentCheckboxEvent;
    let purchaseEvent;
    let purchasePaymentConfirmationDialogMode: boolean = false;

    async function getPurchasesHistory() {
        const purchases = await Employee.getPurchases();
        items = purchases.map(purchase => {
            const { _id, completed, date, paid, price, product } = purchase;
            return {
                _id,
                completed,
                date: new Date(date).toLocaleDateString('pl', { day: "numeric", month: "short", year: "numeric", hour: "numeric", minute: "numeric" }),
                free: price !== 0 ? false : true,
                paid,
                price: Currency.format(price),
                product
            }
        });
        items = items.reverse();
    }

    function handlePaymentConfirmation(e: Checkbox, purchase) {
        toasts.clearAll();
        purchasePaymentConfirmationDialogMode = true;
        paymentCheckboxEvent = e;
        purchaseEvent = purchase;
    }

    LATEST_PURCHASE.subscribe(() => {
        getPurchasesHistory();
    })
</script>

{#if items && items.length}
    <Table {headers} {items}>
        <div let:header let:item slot="item" class="row">
            {#if header.value !== 'paid'}
                {item[header.value]}
            {:else}
                {#if !item['free']}
                    <Checkbox on:change={(e) => handlePaymentConfirmation(e, item)} checked={item['paid']} disabled={item['completed']} />
                    <small>
                        {#if item['paid']}
                            {item['completed'] ? 'Opłacone i rozliczone przez zarządcę' : 'Opłacone - czeka na rozliczenie przez zarządcę'}
                        {:else}
                            Nieopłacone
                        {/if}
                    </small>
                {:else}
                    <Dot info /><small>Nie wymaga płatności</small>
                {/if}
            {/if}
        </div>
    </Table>
    {#if purchasePaymentConfirmationDialogMode}
        <PurchasePaymentConfirmationDialog bind:paymentCheckboxEvent bind:purchaseEvent bind:purchasePaymentConfirmationDialogMode bind:items />
    {/if}
{:else}
    <h3>Na tym koncie nie dokonano jeszcze żadnego zakupu.</h3>
{/if}

<style lang="scss">
    .row {
        display: flex;
        align-items: center;

        small {
            margin-left: 0.25rem;
            font-size: 0.65rem;
            max-width: 170px;
            line-height: 11px;
        }
    }
</style>